import _ from 'lodash';
export default {
    /**
     * Find the current question by page ID
     * @param questions
     * @param id
     * @return {*}
     */
    find(questions, id) {
        return _.find(questions, ['id', parseInt(id)]);
    },
};
